import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { Label } from '@/components/Button/styles'
import {
  ContentUnavailableWrapper,
  StyledScrollContainer,
} from '@/containers/Subscriptions/styles'

export const PaymentPopupContainer = styled(FocusNode)`
  position: fixed;
  background: ${(props) => props.theme.colors.dialogPopup.overlay};
  height: 1080px;
  width: 1920px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 13;
  ${StyledScrollContainer} {
    padding: 0 79px;
    height: 600px;
  }
  ${ContentUnavailableWrapper} {
    margin: 0 32px;
    height: 600px;
  }
`

export const PaymentPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 1070px;
  height: 920px;
  padding: 64px 0;
  background: linear-gradient(
    108deg,
    ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
    ${(props) => props.theme.colors.dialogPopup.background.end} 100%
  );
  border-radius: 24px;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
`
export const Title = styled.h2`
  width: 100%;
  font-size: 32px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.text};
  font-weight: 700;
  text-transform: uppercase;
  padding-bottom: 48px;
  text-align: center;
`

export const Actions = styled.div`
  display: flex;
  align-self: flex-end;
  justify-content: center;
  width: 100%;
  min-height: 64px;
  ${Label} {
    text-align: left;
  }
`
